import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
// import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Loader from "../../../../../customComponents/CustomLoader";

const AddItemCategory = () => {
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const [validationErrors, setValidationErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [userTypedd, setUserTypedd] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  const [hsncodeOptions, setHsncodeOptions] = useState([]);
  const [warrantyOptions, setWarrantyOptions] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("business_partner_id");
  const [taxsetDropdown, setTaxSet] = useState([]);


  useEffect(()=>{
fetchItemDD()
fetchUnitDD()
fetchHsncodeDD()
fetchWarrrantyDD() 
fetchTaxSetDropdown() 
  },[formData?.business_partner_id])

  const fetchWarrrantyDD = async () => {
    try {

      const payload = {
        orderBy: 'warranty_id desc',
        page: 0,
        pageSize: 100,
      }

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post('/warranty/ddlwarranty', payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }
      });

      const options = response.data.data.data.map(product => ({
        label: product.NAME,
        value: product.ID,
      }));

      setWarrantyOptions(options);
    } catch (error) {
      console.error('Error fetching product options:', error);
    }
  };
  const fetchUnitDD = async () => {
    try {

      const payload = {
        orderBy: 'unit_id desc',
        page: 0,
        pageSize: 100,
      }

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post('/unit/ddlunit', payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }
      });

      const options = response.data.data.data.map(product => ({
        label: product.NAME,
        value: product.ID,
      }));

      setUnitOptions(options);
    } catch (error) {
      console.error('Error fetching product options:', error);
    }
  };
  const fetchHsncodeDD = async () => {
    try {

      const payload = {
        orderBy: 'hsncode_id desc',
        page: 0,
        pageSize: 100,
      }

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post('/hsncode/ddlhsncode', payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }
      });

      const options = response.data.data.data.map(product => ({
        label: product.NAME,
        value: product.ID,
      }));

      setHsncodeOptions(options);
    } catch (error) {
      console.error('Error hsncode options:', error);
    }
  };
  const fetchTaxSetDropdown = async () => {
    try {
      const response = await axiosInstance.post(
        "/tax/ddltax",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data;
      console.log(formattedData, "VARIANTDATA");

      const variantData = formattedData.map((data) => ({
        value: data.ID,
        label: data.NAME,
        tax_percent: data?.tax_percent,
      }));

      setTaxSet(variantData);
    } catch (error) {
      console.error("Error fetching department list:", error);
    }
  };


  const fetchItemDD = async () => {
    try {

      const payload = {
        orderBy: 'item_id desc',
        page: 0,
        pageSize: 100,
      }

    

      const response = await axiosInstance.post('/itemtype/list', payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        }
      });

      const options = response.data.data.data.map(product => ({
        label: product.itemtype,
        value: product.itemtype_desc,
      }));

      setProductOptions(options);
    } catch (error) {
      console.error('Error fetching product options:', error);
    }
  };

  const handleFormSubmit = async (data) => {
    const errors = {};
    let isValid = true;

    // Validate form fields
    ItemInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!data[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.required &&
          field.validation &&
          field.validation.pattern &&
          !field.validation.pattern.test(data[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    // If validation fails, set errors and return
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    console.log("data", data);

    // SweetAlert confirmation before API call
    showCustomAlert({
      title: "Confirmation",
      text: "Are you sure you want to create this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
      callback: async () => {
        const payload = {
          part_category_name: data.part_category_name,
          itemtype: data.itemType,
          part_category_desc:data.part_category_desc,
          // item_code: data.itemCode,
          // selling_price: data.sellingPrice,
          // warranty_id: data.warranty,
          // hsnCode_id: data.hsnCode,
          // Unit_id: data.unitQuantity,
          // tax_id:data?.taxid,
          status: data.status === true? 1 : 0,
        };

      

        try {
          setLoading(true);
          const response = await axiosInstance.post("partcategory/create", payload, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          });

          console.log("API Response:", response.data);

          // Success alert after creation
          showCustomAlert({
            title: "Success",
            text: "Item created successfully.",
            icon: "success",
            confirmButtonText: "OK",
            callback: () => {
              navigate("/admin/manage-product/item-category");
            },
          });
        } catch (error) {
         
          const errorMessage = error.response?.data?.message;
          showErrorAlert({
            title: "Something went wrong",
            text:
              errorMessage ||
              "An error occurred while processing your request.",
            callback: () => {
              // Optional: code to execute after confirming the alert
              console.log("Error alert confirmed");
            },
          });
        } finally {
          setLoading(false);
        }
      },
    });
  };

  const ItemInputs = [
    {
      name: "itemType",
      label: "Item Type",
      type: "dropdown",
      options: productOptions,
      required: true,
      validation: {
        required: true,
      },
      gridClass: "col-lg-4",
    },
    {
        name: "part_category_name",
        label: "Item Category Name",
        placeholder: "Enter Item Name",
        type: "text",
        required: true,
        validation: {
          required: true,
          pattern: /^[A-Za-z0-9-\s]*$/,
          message: "Special symbols are not allowed",
        },
        gridClass: "col-lg-4",
      },
      {
        name: "part_category_desc",
        label: "Item Category Description",
        placeholder: "Enter Item Name",
        type: "text",
        required: true,
        validation: {
          required: true
        },
        gridClass: "col-lg-4",
      },
    // {
    //   name: "itemCode",
    //   label: "Item Code",
    //   placeholder: "Enter Item Code",
    //   type: "text",
    //   required: true,
    //   validation: {
    //     required: true,
    //   },
    //   gridClass: "col-lg-4",
    // },
  
    // {
    //   name: "sellingPrice",
    //   label: "Selling Price",
    //   placeholder: "Enter Selling Price",
    //   type: "number",
    //   validation: {
    //     required: true,
    //     pattern: /^\d+(\.\d{1,2})?$/, // Allows up to 2 decimal places
    //     message: "Only digits and up to 2 decimal places are allowed",
    //   },
    //   maxLength: 13, // Maximum length restriction
    //   required: true,
    //   gridClass: "col-lg-4",
    // },
    
    // {
    //   name: "warranty",
    //   label: "Warranty",
    //   type: "dropdown",
    //   required: true,
    //   options: warrantyOptions,
    //   validation: {
    //     required: true,
    //   },
    //   gridClass: "col-lg-4",
    // },
     
    // {
    //   name: "taxid",
    //   label: "Tax ID",
    //   type: "dropdown",
    //   required: true,
    //   options: taxsetDropdown,
    //   validation: {
    //     required: true,
    //   },
    //   gridClass: "col-lg-4",
    // },
    // {
    //   name: "hsnCode",
    //   label: "HSN Code",
    //   //placeholder: "Enter HSN Code",
    //   type: "dropdown",
    //   options: hsncodeOptions,
    //   validation: {
    //     required: true,
    //    // pattern: /^[0-9\s]*$/,
    //     //message: "Only Digits are allowed*",
    //   },
    //   required: true,
    //   gridClass: "col-lg-4",
    // },
    // {
    //   name: "unitQuantity",
    //   label: "Unit",
    //   type: "dropdown",
    //   required: true,
    //   options: unitOptions,
    //   validation: {
    //     required: true,
    //   },
    //   gridClass: "col-lg-4",
    // },
    {
      name: "status",
      label: "Status",
      type: "toggle",
      
      gridClass: "col-lg-4",
    },
  ];

  return (
    <>
      <div>
    {loading ? (
      <Loader />
    ) : (
      <><div
              className="backbutton mt-2 mb-2"
              onClick={() => navigate("/admin/manage-product/item")}
            >
              <img src={backicon} alt="back" />
              <span className="backbtntitle">Add Item Category</span>
            </div><div className="form-container">
                <span className="cust-det-title mt-2 mb-2">
                  Please Enter Item Details
                </span>
                <DynamicForm
                  formConfig={ItemInputs}
                  formData={formData}
                  setFormData={setFormData}
                  onSubmit={handleFormSubmit}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors} />
              </div><div className="btncontainer mt-3">
                <button
                  onClick={() => {
                    handleFormSubmit(formData);
                  } }
                  className="submit-btn"
                >
                  Submit
                </button>
              </div></>
        )}
</div>
    </>
  );
};

export default AddItemCategory;
